<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle2"><a id="page_v"></a><a id="contents"></a>CONTENTS</h1>
<p class="toc2"><a href="#/06_foreword#fore">Introduction by Lon Milo DuQuette</a></p>
<p class="toc2"><a href="#/07_preface#preface">Preface</a></p>
<p class="toc2"><a href="#/08_noteonsafety#note">A Note on Safety</a></p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc">CHAPTERS</p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc1"><a href="#/09_chapter01#c01">1) The Ritual of the Mark of the Beast</a></p>
<p class="toc1"><a href="#/10_chapter02#c02">2) The Invocation of Horus</a></p>
<p class="toc1"><span href="#/11_chapter03#c03" title="Link target outside of Sample">3) Invocation of the Holy Spirit (Isis)</span></p>
<p class="toc1"><span href="#/12_chapter04#c04" title="Link target outside of Sample">4) A Ritual to Invoke HICE</span></p>
<p class="toc1"><span href="#/13_chapter05#c05" title="Link target outside of Sample">5) A Rite of Isis</span></p>
<p class="toc1"><span href="#/14_chapter06#c06" title="Link target outside of Sample">6) Roots of Thelema I - A Mithraic Liturgy</span></p>
<p class="toc1"><span href="#/15_chapter07#c07" title="Link target outside of Sample">7) Roots of Thelema II - The Bacchanal</span></p>
<p class="toc1"><span href="#/16_chapter08#c08" title="Link target outside of Sample">8) Roots of Thelema III - Goetia</span></p>
<p class="toc1"><span href="#/17_chapter09#c09" title="Link target outside of Sample">9) The Brazen Head</span></p>
<p class="toc1"><span href="#/18_chapter10#c10" title="Link target outside of Sample">10) An Evocation of Bartzabel the Spirit of Mars</span></p>
<p class="toc1"><span href="#/19_chapter11#c11" title="Link target outside of Sample">11) The Supreme Ritual</span></p>
<p class="toc1"><span href="#/20_chapter12#c12" title="Link target outside of Sample">12) The Ritual of Consecration of an High Priest of L.I.L.</span></p>
<p class="toc1"><span href="#/21_chapter13#c13" title="Link target outside of Sample">13) The Ritual of Initiation of a Thelemite</span></p>
<p class="toc1"><span href="#/22_chapter14#c14" title="Link target outside of Sample">14) Breaking of Bread</span></p>
<p class="toc1"><span href="#/23_chapter15#c15" title="Link target outside of Sample">15) The Mass of Babalon</span></p>
<p class="toc">APPENDICES:</p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc1"><span href="#/24_appendixi#app-i" title="Link target outside of Sample">I) Rituals from Liber O</span></p>
<p class="toc1"><span href="#/25_appendixii#app-ii" title="Link target outside of Sample">II) The 72 Spirits of the Goetia</span></p>
<p class="toc1"><span href="#/26_appendixiii#app-iii" title="Link target outside of Sample">III) Three Holy Books</span></p>
<p class="toc1"><span href="#/27_appendixiv#app-iv" title="Link target outside of Sample">IV) Ritual J</span></p>
<p class="toc1"><span href="#/28_appendixv#app-v" title="Link target outside of Sample">V) Rituel de la Fraction du Pain</span></p>
<p class="toc1"><span href="#/29_appendixvi#app-vi" title="Link target outside of Sample">VI) Cakes of Light</span></p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc"><span href="#/30_bibliography#bib" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?abfdd170